export enum PrismPlugin {
  CommandLine = 'command-line',
  LineHighlight = 'line-highlight',
  LineNumbers = 'line-numbers',
}
